export const BUDGET_STATES = [
    'ra_completed',
    'who_sent_budget',
    'unicef_sent_budget',
    'gpei_consolidated_budgets',
    'submitted_to_rrt',
    'feedback_sent_to_gpei',
    're_submitted_to_rrt',
    'submitted_to_orpg_operations1',
    're_submitted_to_orpg_operations1',
    'feedback_sent_to_rrt1',
    'submitted_to_orpg_wider',
    'submitted_to_orpg_operations2',
    're_submitted_to_orpg_operations2',
    'submitted_for_approval',
    'feedback_sent_to_orpg_operations_unicef',
    'feedback_sent_to_orpg_operations_who',
    'approved_by_who',
    'approved_by_unicef',
    'approved',
    'approval_confirmed',
];

export const BUDGET_REQUEST = [
    'ra_completed',
    'who_sent_budget',
    'unicef_sent_budget',
    'gpei_consolidated_budgets',
];

export const RRT_REVIEW = [
    'submitted_to_rrt',
    'feedback_sent_to_gpei',
    're_submitted_to_rrt',
];

export const ORPG_REVIEW = [
    'submitted_to_orpg_operations1',
    'feedback_sent_to_rrt1',
    're_submitted_to_orpg_operations1',
    'submitted_to_orpg_wider',
    'submitted_to_orpg_operations2',
    'feedback_sent_to_rrt2',
    're_submitted_to_orpg_operations2',
];

export const REVIEW_FOR_APPROVAL = [
    'submitted_for_approval',
    'feedback_sent_to_orpg_operations_unicef',
    'feedback_sent_to_orpg_operations_who',
    'approved_by_who',
    'approved_by_unicef',
    'approved',
    'approval_confirmed',
];

export const WORKFLOW_SUFFIX = '_at_WFEDITABLE';
